import { render, staticRenderFns } from "./DailyRiskAccount.vue?vue&type=template&id=7718fcc6&scoped=true"
import script from "./DailyRiskAccount.vue?vue&type=script&lang=js"
export * from "./DailyRiskAccount.vue?vue&type=script&lang=js"
import style0 from "./DailyRiskAccount.vue?vue&type=style&index=0&id=7718fcc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718fcc6",
  null
  
)

export default component.exports